/** Do not edit directly **/
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  color: var(--sy-accent);
  text-decoration: none;
}

:host(:hover) {
  text-decoration: underline;
}

:host {
  display: inline-block;
  cursor: pointer;
}
:host a {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  line-height: inherit;
  color: inherit;
  text-align: inherit;
  text-decoration: inherit;
  text-indent: inherit;
  text-overflow: inherit;
  text-transform: inherit;
  letter-spacing: inherit;
  white-space: inherit;
}